//Text Dissappears on Focus
jQuery.fn.temporaryText = function(str) {
	if (this.val()=='') this.val(str);
	this.focus(function(){			
		if($(this).val()==str) $(this).val('');
	}).blur(function(){			
		if($(this).val()=='') $(this).val(str);
	});
}


// Catwalk Animation
jQuery.fn.catwalk = function() {

	this.find('div.model').hover(
		function(){
			$(this).find('ul').fadeIn('fast');
		},
		function(){
			$(this).find('ul').fadeOut('fast');
		}
	).find('ul').hide();

}


// Solves bug - not sure if it breaks analytics though...
var URCHINFIELD = null;
function getUrchinFieldValue() {}